<template>
	<v-snackbar
		v-model="snackbar.active"
		color="third bodybackground--text"
		:bottom="snackbar.y === 'bottom'"
		:left="snackbar.x === 'left'"
		:right="snackbar.x === 'right'"
		:timeout="snackbar.timeout"
		:top="snackbar.y === 'top'"
	>
		{{ snackbar.texto }}
		<v-btn
			depressed
			color="primary navbartext--text"
			@click="$store.commit('setActiveSnackbar',false)"
		>
			Cerrar
		</v-btn>
	</v-snackbar>
</template>

<script>
import { mapState } from 'vuex'

export default {
	computed: {
		...mapState(['snackbar'])
	}
}
</script>

